import Box from '@mui/material/Box';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';

const PatientSchedulingSearchMethodForm = ({
  onSubmit,
  stepNum = 0,
  subtitle = 'Choose your preferred search',
}) => {
  return (
    <Stack spacing={1} alignItems='center'>
      <Typography variant='h2'>Step {stepNum + 1}: How would you like to search?</Typography>
      <Typography>{subtitle}</Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          onChange={(e, val) => onSubmit(e, val)}
          useColoredBackground={true}
          options={[
            {
              label: 'Find By Availability', 
              value: 'BY_AVAILABILITY', 
              Icon: AccessTimeIcon, 
              color: 'primary',
              description: 'Browse providers with open time slots that match your schedule',
              xs: 12,
              md: 6,
              lg: 6,
              xl: 6,
            },
            {
              label: 'Search Our Providers', 
              value: 'BY_PROVIDER', 
              Icon: SearchIcon, 
              color: 'purple',
              description: 'Search by specialty, name, or condition to find the perfect provider',
              xs: 12,
              md: 6,
              lg: 6,
              xl: 6,
            },
          ]}
        />
      </Box>
    </Stack>
  );
};

export default PatientSchedulingSearchMethodForm;